/* Elavate product page behaviours.
   Gallery, plan tabs, variant pickers, gift unlocking, references toggle and
   the ingredients slider — ported from the source theme at
   https://elavate.com/products/multi-collagen-main */
(function () {
  'use strict';

  var ingredientsSlider;

  /* ------------------------------------------------------------------ *
   * Media gallery: horizontal scroll-snap slider + thumbnail strip.
   * ------------------------------------------------------------------ */
  function initGallery() {
    document.querySelectorAll('.el-section [data-gallery]').forEach(function (gallery) {
      var viewer = gallery.querySelector('[data-gallery-viewer]');
      var thumbs = gallery.querySelector('[data-gallery-thumbnails]');
      if (!viewer) return;

      var slides = Array.prototype.slice.call(viewer.querySelectorAll('.slider__slide'));
      if (!slides.length) return;

      var current = gallery.querySelector('.slider-counter--current');
      var total = gallery.querySelector('.slider-counter--total');
      if (total) total.textContent = slides.length;

      // The active slide is tracked here rather than read back from the DOM:
      // above 990px the media list is not a scroller (the source CSS only makes
      // it one on mobile), so scroll position says nothing about which slide is
      // showing -- the .is-active class does.
      var index = 0;

      function isScrollable() {
        return viewer.scrollWidth > viewer.clientWidth + 1;
      }

      function render() {
        slides.forEach(function (slide, n) { slide.classList.toggle('is-active', n === index); });
        if (current) current.textContent = index + 1;
        if (isScrollable()) {
          viewer.scrollTo({ left: slides[index].offsetLeft - viewer.offsetLeft, behavior: 'smooth' });
        }
        if (!thumbs) return;
        thumbs.querySelectorAll('.thumbnail').forEach(function (btn, n) {
          if (n === index) btn.setAttribute('aria-current', 'true');
          else btn.removeAttribute('aria-current');
        });
        var activeThumb = thumbs.querySelectorAll('.thumbnail-list__item')[index];
        if (activeThumb) scrollIntoStrip(thumbs, activeThumb);
      }

      function goTo(next) {
        index = (next + slides.length) % slides.length;
        render();
      }

      var buttons = gallery.querySelector('.slider-buttons');
      if (buttons) {
        var prev = buttons.querySelector('.slider-button--prev');
        var next = buttons.querySelector('.slider-button--next');
        if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
        if (next) next.addEventListener('click', function () { goTo(index + 1); });
      }

      // While the list IS a scroller (mobile), swiping should update the counter.
      var scrollTimer;
      viewer.addEventListener('scroll', function () {
        if (!isScrollable()) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var nearest = 0;
          var best = Infinity;
          slides.forEach(function (slide, n) {
            var delta = Math.abs(slide.offsetLeft - viewer.offsetLeft - viewer.scrollLeft);
            if (delta < best) { best = delta; nearest = n; }
          });
          if (nearest !== index) { index = nearest; render(); }
        }, 80);
      }, { passive: true });

      if (thumbs) {
        thumbs.querySelectorAll('.thumbnail').forEach(function (btn, n) {
          btn.addEventListener('click', function (event) {
            event.preventDefault();
            goTo(n);
          });
        });

        gallery.querySelectorAll('.thumbnail-slider > .slider-button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var item = thumbs.querySelector('.thumbnail-list__item');
            if (!item) return;
            var step = parseInt(btn.getAttribute('data-step') || '3', 10);
            var by = item.getBoundingClientRect().width * step;
            thumbs.scrollBy({ left: btn.classList.contains('slider-button--prev') ? -by : by, behavior: 'smooth' });
          });
        });
      }

      render();
    });
  }

  function scrollIntoStrip(strip, item) {
    var stripRect = strip.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    if (itemRect.left >= stripRect.left && itemRect.right <= stripRect.right) return;
    strip.scrollBy({ left: itemRect.left - stripRect.left, behavior: 'smooth' });
  }

  /* ------------------------------------------------------------------ *
   * Buy box: North Alpine-style "Bundle & Save" ladder, one-time only.
   * Selecting a tier reveals a flavour dropdown per bag; the choices ride
   * along to the cart as a single line-item property. Price + the matched
   * variant come from the chosen tier.
   * ------------------------------------------------------------------ */
  function initBundle() {
    document.querySelectorAll('.el-section [data-el-bundle]').forEach(function (box) {
      var info = box.closest('.product__info-container') || document;
      var form = info.querySelector('form[data-type="add-to-cart-form"]');
      var variantInput = info.querySelector('[data-el-variant-input]');
      var propsWrap = info.querySelector('[data-el-properties]');
      var priceEl = info.querySelector('[data-el-price]');
      var compareEl = info.querySelector('[data-el-compare]');
      var submit = info.querySelector('.product-form__submit');
      var label = submit ? submit.querySelector('.button-label') : null;
      var dataEl = info.querySelector('[data-el-variants]');
      var atcText = label ? label.textContent.trim() : 'Add to cart';

      var catalogue = null;
      if (dataEl) {
        try { catalogue = JSON.parse(dataEl.textContent); } catch (e) { catalogue = null; }
      }

      var quantityName = box.getAttribute('data-quantity-option');
      var tiers = Array.prototype.slice.call(box.querySelectorAll('[data-el-tier]'));
      if (!tiers.length) return;

      function selectedTier() {
        return box.querySelector('[data-el-tier].is-selected') || tiers[0];
      }

      /* Match the tier's option value against the product's pack-size option. */
      function matchVariant(value) {
        if (!catalogue || !catalogue.variants || !catalogue.variants.length) return null;
        var names = catalogue.options || [];
        var idx = names.indexOf(quantityName);
        if (idx < 0 || value == null) return null;
        return catalogue.variants.find(function (v) { return v.options[idx] === value; }) || null;
      }

      /* Reveal the thumbnail matching this bag's pick. Every flavour's image is
         already in the markup (Liquid's asset_url is not reachable from here),
         so swapping is just a matter of which one stays visible. */
      function syncThumb(select) {
        var bag = select.closest('.el-bundle-bag');
        if (!bag) return;
        var thumbs = bag.querySelectorAll('[data-el-flavour-thumb]');
        thumbs.forEach(function (img) {
          img.hidden = img.getAttribute('data-el-flavour-thumb') !== select.value;
        });
      }

      /* Write the per-bag flavour picks into the form as one line-item property. */
      function syncProperties(tier) {
        if (!propsWrap) return;
        propsWrap.innerHTML = '';
        var selects = tier.querySelectorAll('[data-el-flavour]');
        if (!selects.length) return;
        var parts = [];
        selects.forEach(function (sel) {
          parts.push('Bag ' + sel.getAttribute('data-bag') + ': ' + sel.value);
        });
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Flavours]';
        input.value = parts.join(' · ');
        propsWrap.appendChild(input);
      }

      function updatePrice(tier) {
        var radio = tier.querySelector('.el-bundle-tier__input');
        var total = radio ? radio.getAttribute('data-total') : '';
        var compare = radio ? radio.getAttribute('data-compare') : '';
        if (priceEl && total) priceEl.textContent = total;
        if (compareEl) {
          if (compare) {
            compareEl.textContent = compare;
            compareEl.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
          }
        }
      }

      function updateVariant(tier) {
        var radio = tier.querySelector('.el-bundle-tier__input');
        var match = radio ? matchVariant(radio.value) : null;
        if (match) {
          if (variantInput) variantInput.value = match.id;
          if (submit) submit.disabled = !match.available;
          if (label) label.textContent = match.available ? atcText : 'Sold out';
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* history not available */ }
        } else {
          // Demo / unmatched product: keep the form usable and show the tier price.
          if (submit) submit.disabled = false;
          if (label) label.textContent = atcText;
        }
      }

      function selectTier(tier) {
        tiers.forEach(function (t) {
          var on = t === tier;
          t.classList.toggle('is-selected', on);
          var radio = t.querySelector('.el-bundle-tier__input');
          if (radio) radio.checked = on;
        });
        updatePrice(tier);
        updateVariant(tier);
        syncProperties(tier);
      }

      tiers.forEach(function (tier) {
        var radio = tier.querySelector('.el-bundle-tier__input');
        if (radio) {
          radio.addEventListener('change', function () { if (radio.checked) selectTier(tier); });
        }
        tier.querySelectorAll('[data-el-flavour]').forEach(function (sel) {
          syncThumb(sel);
          sel.addEventListener('change', function () {
            syncThumb(sel);
            if (tier.classList.contains('is-selected')) syncProperties(tier);
            else selectTier(tier);
          });
        });
      });

      // Guarantee the latest picks are attached even if a change event was missed.
      if (form) form.addEventListener('submit', function () { syncProperties(selectedTier()); });

      selectTier(selectedTier());
    });
  }

  /* ------------------------------------------------------------------ *
   * References: click-to-toggle disclosure.
   * ------------------------------------------------------------------ */
  function initReferences() {
    document.querySelectorAll('.el-section .product--Reference').forEach(function (wrap) {
      var toggle = wrap.querySelector('.product--Reference-Toggle');
      var content = wrap.querySelector('.product--Reference-Content');
      if (!toggle || !content || toggle.dataset.elBound) return;
      toggle.dataset.elBound = '1';

      function setOpen(open) {
        wrap.classList.toggle('open', open);
        content.style.display = open ? 'block' : 'none';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setOpen(!wrap.classList.contains('open'));
      });
      toggle.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setOpen(!wrap.classList.contains('open'));
      });

      setOpen(false);
    });
  }

  /* ------------------------------------------------------------------ *
   * Ingredients carousel — config read off the running Swiper on the
   * source site, reproduced verbatim.
   * ------------------------------------------------------------------ */
  function initIngredientsSlider() {
    var el = document.querySelector('.section-el-pdp-ingredients .image-text-columns-slider-inner');
    if (!el || typeof Swiper === 'undefined') return;
    if (ingredientsSlider) ingredientsSlider.destroy(true, true);
    ingredientsSlider = new Swiper(el, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 8,
      loop: false,
      centeredSlides: false,
      grabCursor: true,
      scrollbar: { el: '.swiper-scrollbar', draggable: true, dragSize: 'auto', snapOnRelease: true, hide: false },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: {
        576: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 8 },
        750: { slidesPerView: 2, slidesPerGroup: 1 },
        990: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 30 },
        1200: { slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 30 }
      }
    });
  }

  /* Nutritional-info modal behind the "SEE ALL INGREDIENTS" link. */
  function initIngredientsModal() {
    var modal = document.querySelector('.el-section .ingredient-model');
    if (!modal) return;
    var openers = document.querySelectorAll('.el-section .viewall-btn a, .el-section .viewall-btn button');

    function setOpen(open) {
      modal.classList.toggle('open', open);
      modal.style.display = open ? 'block' : 'none';
    }

    openers.forEach(function (opener) {
      if (opener.dataset.elBound) return;
      opener.dataset.elBound = '1';
      opener.addEventListener('click', function (event) {
        event.preventDefault();
        setOpen(true);
      });
    });

    modal.querySelectorAll('.close').forEach(function (btn) {
      if (btn.dataset.elBound) return;
      btn.dataset.elBound = '1';
      btn.addEventListener('click', function () { setOpen(false); });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) setOpen(false);
    });

    setOpen(false);
  }

  /* ------------------------------------------------------------------ *
   * Scroll-in animation, mirroring the source's IntersectionObserver reveal.
   * (el-landing.js does the same job, but only loads on the index template.)
   * ------------------------------------------------------------------ */
  function initScrollAnimations() {
    var targets = document.querySelectorAll('.el-section .scroll-trigger:not(.el-in)');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('el-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('el-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -50px 0px', threshold: 0 });
    targets.forEach(function (t) { io.observe(t); });
  }

  function boot() {
    initGallery();
    initBundle();
    initReferences();
    initIngredientsSlider();
    initIngredientsModal();
    initScrollAnimations();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initIngredientsSlider, 300);
  });

  document.addEventListener('shopify:section:load', boot);
})();
